import React from "react";
import MascotScreen from "./MascotScreen";

export default function TemporaryScreen(props) {
  return <MascotScreen {...props} duration={5000}/>;
}
